/**
 * Renderer tone-mapping policy for mixed PLATEAU city + point-cloud scenes.
 * Forensic audit P0: PBR 3D Tiles need ACES; LiDAR RGB needs NoToneMapping.
 */
import * as THREE from 'three';
import { PLATEAU_FEATURES } from './plateauFeatures';

/** PLATEAU textured buildings look best at ~1.4 under ACESFilmic. */
export const PLATEAU_CITY_TONE_MAPPING_EXPOSURE = 1.4;

const CITY_LAYER_KINDS = new Set(['3dtiles', 'bim']);

export function layerKindNeedsCityToneMapping(kind: string): boolean {
  return CITY_LAYER_KINDS.has(kind);
}

export function resolvePlateauToneMapping(
  mountedLayerKinds: readonly string[],
): { toneMapping: THREE.ToneMapping; exposure: number } {
  const hasCityTiles = mountedLayerKinds.some((kind) => layerKindNeedsCityToneMapping(kind));
  const forceCity = PLATEAU_FEATURES.cityToneMapping;
  const useAces = hasCityTiles || forceCity;

  if (useAces) {
    return {
      toneMapping: THREE.ACESFilmicToneMapping,
      exposure: PLATEAU_CITY_TONE_MAPPING_EXPOSURE,
    };
  }

  return {
    toneMapping: THREE.NoToneMapping,
    exposure: 1.0,
  };
}

export function applyPlateauRendererToneMapping(
  renderer: { toneMapping?: THREE.ToneMapping; toneMappingExposure?: number } | null | undefined,
  mountedLayerKinds: readonly string[],
): boolean {
  if (!renderer) return false;

  const { toneMapping, exposure } = resolvePlateauToneMapping(mountedLayerKinds);
  const changed =
    renderer.toneMapping !== toneMapping || renderer.toneMappingExposure !== exposure;

  renderer.toneMapping = toneMapping;
  renderer.toneMappingExposure = exposure;

  return changed;
}
